import { render, staticRenderFns } from "./PayableRateDetailByArchiving.vue?vue&type=template&id=4348760e&scoped=true"
import script from "./PayableRateDetailByArchiving.vue?vue&type=script&lang=js"
export * from "./PayableRateDetailByArchiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4348760e",
  null
  
)

export default component.exports